import { Component, OnInit, ViewChild } from '@angular/core';
import { Config, Events, Nav } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/observable/fromPromise';

export interface ISmsData {
  name: string;
  title: string;

  selectedId: string;
  selectedLogo: string;
  selectedNumber: string;

  radios: Array<any>;
}

@Component({
  templateUrl: 'app.template.html'
})
export class SmsWallApp implements OnInit {

  @ViewChild(Nav) nav: Nav;

  rootPage: any;
  isLoggedIn = false;

  info: ISmsData = {
    name: '',
    title: '',
    selectedId: '',
    selectedLogo: '',
    selectedNumber: '',
    radios: []
  };

  constructor(
    public events: Events,
    public storage: Storage,
    public config: Config
  ) {

    this.rootPage = 'LoginPage';
  }

  ngOnInit(): void {
    Observable.forkJoin([
      Observable.fromPromise(this.storage.get('data')),
      Observable.fromPromise(this.storage.get('hasLoggedIn'))
    ])
      .subscribe(data => {
        if (data[0]) {
          this.info = JSON.parse(data[0]);
          this.config.set('radioId', this.info.selectedId);
          this.events.publish('radioId', this.info.selectedId);
        }

        this.isLoggedIn = data[1];
      });

    this.events.subscribe('user:login', (data: ISmsData) => {
      this.info = data;
      this.isLoggedIn = true;
    });
  }

  openPage = (pageName: string): void => {
    switch (pageName) {
      case 'sms':
        this.nav.setRoot('SmsPage');
        break;
      case 'bulk':
        this.nav.setRoot('BulkSmsPage');
        break;
      case 'contact':
        this.nav.setRoot('ContactPage');
        break;
      case 'export':
        this.nav.setRoot('ExportPage');
        break;
      case 'info':
        this.nav.setRoot('InfoPage');
        break;
      default:
        this.nav.setRoot('SmsPage');
    }
  };

  logOut(): void {
    this.isLoggedIn = false;
    this.storage.clear();

    this.nav.setRoot('LoginPage');
  }

  onChange(): void {
    this.info.radios.forEach((radio: any) => {
      if (radio.id === this.info.selectedId) {
        this.info.selectedLogo = radio.logo;
        this.info.selectedNumber = radio.sms_number;
        this.config.set('radioId', radio.id);
        this.config.set('radioName', radio.nev);
        this.events.publish('sms-list:update');

        this.storage.set('data', JSON.stringify(this.info));
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts